var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"transparent-placeholder-image",attrs:{"src":_vm.srcs[_vm.ratio] || _vm.srcs.square,"alt":"Placeholder"}})}
var staticRenderFns = []

export { render, staticRenderFns }